import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddCustomerTypeMutation,
  useDeleteCustomerTypeMutation,
  useEditCustomerTypeMutation,
  useGetCustomerTypesQuery,
} from "../../../../../redux/Service/CustomerTypesApi";

function CustomerTypes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const { data: customerTypesData, isLoading } =
    useGetCustomerTypesQuery(undefined);
  const customerTypes = customerTypesData?.ResponseObject ?? [];

  const [addCustomerType, { isLoading: isAdding }] =
    useAddCustomerTypeMutation();
  const [updateCustomerType, { isLoading: isUpdating }] =
    useEditCustomerTypeMutation();
  const [deleteCustomerType, { isLoading: isDeleting }] =
    useDeleteCustomerTypeMutation();

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد من حذف نوع العميل "${record.CustTypeName}"؟`,
      okText: "نعم",
      cancelText: "لا",
      okType: "danger",
      onOk: async () => {
        try {
          const response = await deleteCustomerType(record.CustTypeID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم الحذف بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleOk = async (values: any) => {
    const body = {
      CustTypeName: values.CustTypeName,
      UpCustTypeID: values.UpCustTypeID,
      ...(isEditing && { CustTypeID: values.CustTypeID }),
    };

    try {
      const response = isEditing
        ? await updateCustomerType(body).unwrap()
        : await addCustomerType(body).unwrap();

      if (response?.ResponseObject === true) {
        message.success(isEditing ? "تم التعديل بنجاح" : "تمت الإضافة بنجاح");
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const resetModal = () => {
    form.resetFields();
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  const columns = [
    { title: "الرقم", dataIndex: "CustTypeID" },
    { title: " نوع العميل", dataIndex: "CustTypeName" },
    { title: "نوع العميل الاعلي", dataIndex: "UpCustTypeName" },
  ];

  return (
    <div className="flex flex-wrap gap-4 relative">
      <div className="grid justify-start my-2">
        <Button
          type="primary"
          style={{ width: "10rem" }}
          onClick={() => setIsModalOpen(true)}
        >
          إضافة
        </Button>
      </div>

      <FormModal
        form={form}
        isModalOpen={isModalOpen}
        isEditing={isEditing}
        handleOk={handleOk}
        handleCancel={handleCancel}
        loading={isAdding || isUpdating}
        customerTypes={customerTypes}
      />

      <DataTable
        columns={columns}
        data={customerTypes}
        isLoading={isLoading || isDeleting}
        handleEditClick={handleEditClick}
        handleDeletClick={handleDeleteClick}
      />
    </div>
  );
}

export default CustomerTypes;
